import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GridApi, GridOptions, ICellRendererParams} from 'ag-grid-community';
import {StepComponent, StepData} from '../../../stepper/step/step.component';
import {StepperService} from '../../../stepper/stepper.service';
import {Step} from '../../../stepper/step/step';
import {ExecutionService} from '../../../stepper/execution/execution.service';
import {untilDestroyed} from 'ngx-take-until-destroy';
import {ExecutionStateEnum} from '../../../stepper/execution/execution-state.enum';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'mydocma-import-step-data-result',
    templateUrl: './step-data-result.component.html',
    styleUrls: ['./step-data-result.component.scss']
})
export class StepDataResultComponent implements StepComponent, OnInit, OnDestroy {

    @Output()
    public importEvent = new EventEmitter();

    @Input()
    public step: Step;

    public isExecutionVisible = false;
    private gridApi: GridApi = null;
    public gridOptions: GridOptions = {
        columnDefs: [],
        rowData: [],
        rowSelection: 'single',
        singleClickEdit: true,
        suppressCellSelection: true,
        suppressDragLeaveHidesColumns: true,
        defaultColDef: {
            suppressSizeToFit: true,
            headerValueGetter: this.localizeHeader.bind(this),
            resizable: true,
        },
        context: {componentParent: this},
        onGridReady: (param) => {
            this.gridApi = param.api;
        }
    };

    constructor(
        private readonly stepperService: StepperService,
        private readonly executionService: ExecutionService,
        private readonly translateService: TranslateService
    ) {
    }

    public ngOnInit() {
        this.executionService.state$
            .pipe(untilDestroyed(this))
            .subscribe(state => {
                this.isExecutionVisible = state !== ExecutionStateEnum.NotStarted;
            });

        this.translateService.onLangChange.subscribe(() => {
            if (this.gridApi?.refreshHeader) {
                this.gridApi.refreshHeader();
            }
        });
    }

    public enter() {
        const stepFilePreview = this.stepperService.getStepByName('filePreview');
        this.renderTableGrid(stepFilePreview.data);

        this.stepperService.setStepData(this.step, {
            error: null,
            data: null,
            valid: true
        });
    }

    public async validate(): Promise<StepData> {
        return {
            error: null,
            data: null,
            valid: true
        };
    }

    public localizeHeader(parameters: ICellRendererParams): string {
        const headerIdentifier = parameters.colDef.headerName;

        return this.translateService.instant(headerIdentifier);
    }

    public import() {
        this.importEvent.emit();
    }

    public async previousStep() {
        await this.stepperService.prevStep();
    }

    public ngOnDestroy() {
    }

    private renderTableGrid(sheetTableData: any[][]) {
        sheetTableData.forEach(((sheetRowArray, rowIndex) => {
            if (rowIndex === 0) {
                let fieldName = 0;
                sheetRowArray.forEach((headerRow) => {
                    this.gridOptions.columnDefs.push({
                        headerName: headerRow,
                        field: (fieldName++).toString()
                    });
                });

                return;
            }

            this.gridOptions.rowData.push(Object.assign({}, sheetRowArray));
        }));
    }
}
